// Who is using the app — set by the sign-in (services/auth.js). The app only renders after
// sign-in, so pages can read it directly. `admin` decides who sees money on the dashboard.
const SIGNED_OUT = { id: null, email: '', name: '', firstName: '', initials: '', role: '', admin: false };

export const CURRENT_USER = { ...SIGNED_OUT };

export const setCurrentUser = (user) => {
  Object.assign(CURRENT_USER, SIGNED_OUT, user || {});
};
